'use client';

import React from 'react';
import styled from 'styled-components';

import { Container } from '@/components/Container';
import { ContactLayout } from '@/components/Layouts/ContactLayout';
import { ContactForm } from '@/features/ContactForm/ContactForm';
import { Map } from '@/features/Map/Map';
import { devices } from '@/styles/breakpoints';
const ContactPage = () => {
  return (
    <ContactLayout>
      <Container style={{ paddingTop: '40px' }}>
        <Wrapper>
          <ContactForm />
          <Map />
        </Wrapper>
      </Container>
    </ContactLayout>
  );
};

export default ContactPage;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;

  @media only screen and ${devices.desktop} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    background-color: white;
  }
`;
